module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-bottom-336157fa.svg";